import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterDownloadsCenterOutletAppPermission = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("downloads-center/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.AppPermission />,
        });
      })
      .catch(reject);
  });
});

export const LazyDownloadsCenterOutletAppPermission = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterDownloadsCenterOutletAppPermission />
    </Suspense>
  );
};
